import { PacksClient } from '../types'
import {GetPackResponseData} from "../types/PacksClient";

export const getPack = (base: PacksClient) => (id: string) =>
  base.requester.get<GetPackResponseData>(`/${id}`, { withCredentials: true })
